import {Alert, AlertTitle, Button} from "@mui/material";
import React from "react";

export interface ErrorProps {
	error: Error;
	resetErrorBoundary: () => void;
}

// todo show meaningful messages and a nice ui when errors happen
export function generalError(props: ErrorProps) {
	if (props.error.message === "Failed to fetch") {
		return <Alert severity="error">
			<AlertTitle>Error</AlertTitle>
			Failed to fetch data from remote service.
			<br/>
			<Button onClick={props.resetErrorBoundary}>TRY AGAIN</Button>
		</Alert>;
	}
	
	return <Alert severity="error">
		<AlertTitle>Error</AlertTitle>
		{props.error.message}
		<br/>
		<Button onClick={props.resetErrorBoundary}>TRY AGAIN</Button>
	</Alert>;
}
